import { PropsWithChildren, createContext, useContext } from 'react';

import type {
  AvailableMetric,
  Treatment,
} from '@spotify/confidence-editor-react';

import { ReportBlockDataProvider } from '../ReportBlockDataContext';

export type ReportEditorDataContextValue = {
  availableMetrics: AvailableMetric[];
  treatments: Treatment[];
};

const ReportEditorDataContext = createContext<ReportEditorDataContextValue>({
  availableMetrics: [],
  treatments: [],
});

export const ReportEditorDataProvider = ({
  value,
  children,
}: PropsWithChildren<{ value: ReportEditorDataContextValue }>) => (
  <ReportBlockDataProvider value={value}>
    <ReportEditorDataContext.Provider value={value}>
      {children}
    </ReportEditorDataContext.Provider>
  </ReportBlockDataProvider>
);

export const useReportEditorData = () => useContext(ReportEditorDataContext);
